import React, { Suspense } from 'react';
import Skeleton from './loading_skeleton';

const CartButton = React.lazy(() => import('shipping/CartButton'));

const CartButtonComponent = (props) => {
    const SkeletonLayout = () => {
        return (
            <Skeleton height='46px' width='74px' />
        )
    }
    return (
        <Suspense fallback={<SkeletonLayout />}>
            <CartButton {...props} />
        </Suspense>
    )
}

export default CartButtonComponent;